import Register from "./components/Register";
import Login from "./components/Login";
import Product from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";
import { ThemeProvider } from "@mui/system";
import theme from "./theme";
import { BrowserRouter, Switch, Route } from "react-router-dom";

export const config = {
  endpoint: `https://qkart-frontend-d7hv.onrender.com/api/v1`,
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Product />
            </Route>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/register">
              <Register />
            </Route>
            <Route path="/checkout">
              <Checkout />
            </Route>
            <Route path="/Thanks">
              <Thanks />
            </Route>
          </Switch>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
